import {
    NO_PERMISSIONS,
    type PermissionLevel,
    type PermissionState,
} from "@kontextwerk/control-web-frame/shared/logic/authorization"

export type { PermissionState }
export { NO_PERMISSIONS }

/** KB scheduling grants own or all employees' planning; there is no role or super shortcut. */
export const KEHRBLATT_SCHEDULING = "kehrblatt.scheduling"

export type EmployeePermissionCapability = "denied" | "restricted" | "all"

export type EmployeePermissionAccess = {
  capability: EmployeePermissionCapability
  employeeIds: string[] | null
}

/**
 * Convert the widest confirmed scope for the given key and level into the employees a UI
 * selection may offer.
 *
 * Returns `null` ids only for an `all` grant, the member's own id for an `own` grant and an empty
 * list otherwise. The member is the represented user during support, never the staff actor.
 */
export const resolveEmployeePermissionAccess = (
  permissions: PermissionState,
  key: string,
  currentUserId: string | null | undefined,
  level: PermissionLevel = "view",
): EmployeePermissionAccess => {
  if (!permissions.allows(key, level)) return { capability: "denied", employeeIds: [] }

  const scope = permissions.highestScope(key, level)

  if (scope === "all") return { capability: "all", employeeIds: null }

  if (scope !== "own" || !currentUserId) return { capability: "denied", employeeIds: [] }

  return { capability: "restricted", employeeIds: [currentUserId] }
}

export const resolveAllowedEmployeeIds = (
  permissions: PermissionState,
  key: string,
  currentUserId: string | null | undefined,
  level: PermissionLevel = "view",
): string[] | null =>
  resolveEmployeePermissionAccess(permissions, key, currentUserId, level).employeeIds
